import { GET_PLAN } from '../Actions/actionTypes';
const initial = {
    Plans: []
};
export default (state=initial,action)=>{
    switch(action.type){

        case GET_PLAN:
            if (action.payload.Plans!==null)
                return action.payload;
            else
                return state;
        default:
            return state;
    }
}